export default "/fonts/vendor/mdui/dist/roboto/Roboto-BoldItalic.woff2?f21b7e045fd077321cdaf92cab817cd3";